import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import sites from '@/router/routes/sites'

export default function useServiceList() {
  const isServiceFormSidebarActive = ref(false)
  const serviceData = ref(null);
  const contentsData = ref(null);
  const { t } = useI18nUtils()
  const blogs = ref([]);
  const toast = useToast()
  const refCatListTable = ref(null);
  const tableColumns = [
    { key: '', label: '', sortable: false },
    { key: 'cover_image', label: t('cover_image'), sortable: false, tdClass:'width-200 p-1' },
    { key: 'title', label: 'Title', sortable: false },
    { key: 'slug', label: 'Slug', sortable: false },
    { key: 'category_name', label:'Category Name', sortable:false},
    { key: 'is_active', label: 'Status', sortable: false },
    { key: 'action', label: '#', sortable: false },
  ]
  const perPage = ref(10)
  const totalService = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const catFilter = ref(null);
  const catsData = ref([]);
  const dataMeta = computed(() => {
    if (totalService.value === 0) {
      return { from: 0, to: 0, of: 0 }
    }

    const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1)
    const to = Math.min(totalService.value, perPage.value * currentPage.value)

    return { from, to, of: totalService.value }
  })

  const fetchCategiryData = () => {
    const getLocalSite = JSON.parse(localStorage.getItem('site'))

    try {
      store.dispatch('app-service/fetchCats', { sites_id: getLocalSite.id })
        .then(response => {
          catsData.value = response.data.data
        })
    } catch(error) {
      console.log(`error fetch category: ${error}`)
    }
  }

  fetchCategiryData()

  const refetchData = () => {
    fetchData()
  }

  watch([currentPage, perPage, searchQuery, statusFilter,catFilter], () => {
    fetchData()
  })

  const fetchData = (ctx, callback) => {
    const offset = perPage.value*(currentPage.value-1);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))

    store
      .dispatch('app-service/fetchServices', {
        limit: perPage.value,
        currentPage: currentPage.value,
        keywords: searchQuery.value,
        order_by:'ordering_count DESC',
        category_id: catFilter.value,
        sites_id: getLocalSite.id
      })
      .then(response => {
        blogs.value  = response.data.data
        // callback(blogs.value)
        const total = response.data.total;
        totalService.value = total
      })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching Category' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const updateBlogsOrdering = ()=>{
    store.dispatch('app-service/updateBlogsOrdering', blogs.value)
  }

    const resolveCatStatusVariant = status => {
       
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }
    const resolveCatStatusnameVariant = status => {
       
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

  const updateService = async (data) => {
    if(data) {
      serviceData.value = data;
      // await store.dispatch("app-service/fetchBlocks", data.slug).then(response => {
      //   serviceData.value = response.data.data
      // });
    } else {
      const getLocalSite = JSON.parse(localStorage.getItem('site'))
      const userStorage = JSON.parse(localStorage.getItem("userData"));

      serviceData.value = {
        id: null,
        title: {},
        description: {},
        slug: {},
        category_id: null,
        is_active: true,
        sites_id: getLocalSite.id,
        created_by: userStorage.id,
        updated_by: userStorage.id,
        featuredImage: null,
        blogFile: null,
        iconFile: null,
        iconImage: null,
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
      };
      contentsData.value  = [];
    }

    fetchData()
    isServiceFormSidebarActive.value = true;
  }

    const deleteData = (id) => {
        store.dispatch('app-service/deleteService', id).then(response=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })

          refetchData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete Blog",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
      }
      
    return {
        isServiceFormSidebarActive,
        serviceData,
        refCatListTable,
        tableColumns,
        perPage,
        totalService,
        currentPage,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        statusFilter,
        dataMeta,
        refetchData,
        fetchData,
        resolveCatStatusVariant,
        resolveCatStatusnameVariant,
        updateService,
        deleteData,
        catsData,
        catFilter,
        t,
        updateBlogsOrdering,
        blogs,

    }
}